import '../App.css';
import React, {useState, useEffect} from 'react';


function AddNewLine(text, outputArray){
  var brTextSplit = text.split("<br>")
    for(var j=0; j<brTextSplit.length-1; j++){
      outputArray.push(brTextSplit[j])
      outputArray.push(<br></br>)
      outputArray.push(<br></br>)
    }
    outputArray.push(brTextSplit[brTextSplit.length-1])
}

/**
 * Component for the header at the top of the page.
 * @return {Component}
 */
function Notice({text,link,word}) {
  var textSplit = text.split("<here>");
  var output = [];
  for(var i=0; i<textSplit.length-1; i++){
    AddNewLine(textSplit[i],output);
    output.push(<a href={link[i]}>{word[i]}</a>)
  }
  AddNewLine(textSplit[textSplit.length-1],output);
  
  output = [
    <b>Please note: </b>,
    "We are excited to share that V-Ray UBL is now supported in AWS Deadline Cloud as of July 15, 2025. If you’re using V-Ray, you can now leverage the new Deadline Cloud UBL feature to render with flexible, usage-based licensing. For setup instructions, please refer to ",
    <a target="_blank" href="https://awsthinkbox.zendesk.com/hc/en-us/articles/22883209044759-AWS-Deadline-Cloud-UBL-for-Deadline-10-on-AWS">this link</a>,
    ".",
    <br />,
    <br />,
    "As we continue transitioning from the legacy system, please note the following key dates and changes: ",
    <ul>
      <li>V-Ray and Renderman UBL purchases on the Thinkbox Marketplace will be available until August 15, 2025. After this date, no additional V-Ray and Renderman UBL hours can be purchased from the legacy marketplace.</li>
      <li>All previously purchased UBL hours from the Thinkbox Marketplace can be used until the final deprecation date of September 30, 2025.</li>
      <li>Yeti and Renderman UBL will not be supported in Deadline Cloud. However, you can continue using Yeti and Renderman with BYOL.</li>
    </ul>,
    <br />,
    "For any questions about existing UBL purchases, please reach out to: ",
    <a href="mailto:support@awsthinkbox.zendesk.com">support@awsthinkbox.zendesk.com</a>,
    "."
  ]

  return (
    <div className="notice-container">
        {output}
    </div>
  );
}


export default Notice;
